import { render, staticRenderFns } from "./GroupMapping.vue?vue&type=template&id=5987f71b&"
import script from "./GroupMapping.vue?vue&type=script&lang=js&"
export * from "./GroupMapping.vue?vue&type=script&lang=js&"
import style1 from "./GroupMapping.vue?vue&type=style&index=1&id=5987f71b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports